
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'customer-portal-app',
  currentProjectVersion: 'static-1.1660',
  depVersions: {
  "customer-portal-app": "static-1.1660",
  "apollo-dlb": "static-3.80",
  "client-types": "static-1.445",
  "data-fetching-client": "static-1.9477",
  "emoji-mart": "static-3.4",
  "enviro": "static-4.387",
  "growth-payments-core": "static-1.24718",
  "head-dlb": "static-1.4754",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.5391",
  "hs-test-utils": "static-1.7804",
  "hub-http": "static-1.5966",
  "hub-http-shared-msw-handlers": "static-1.9472",
  "hubspot-dlb": "static-2.1796",
  "hubspot-prosemirror": "static-1.17595",
  "hubspot-url-utils": "static-1.3917",
  "HubStyleTokens": "static-2.11224",
  "I18n": "static-7.1568",
  "immutable": "static-2.19",
  "jasmine-runner": "static-1.6271",
  "payment-link-components": "static-1.22932",
  "prosemirror": "static-1.13",
  "quartz": "static-1.6733",
  "quartz-core": "static-1.5952",
  "react": "static-7.177",
  "react-colorpicker": "static-2.10008",
  "react-dlb": "static-1.71",
  "react-utils": "static-2.5171",
  "rich-text-lib": "static-1.19466",
  "transmute": "static-2.85",
  "ui-addon-upgrades": "static-9.17650",
  "ui-components-test-utils": "static-1.5362",
  "UIComponents": "static-3.8171",
  "foundations-assets": "static-1.4635",
  "foundations-components": "static-1.7520",
  "foundations-theming": "static-1.4208",
  "foundations-theming-specialty": "static-1.1924",
  "framer-motion": "static-1.67",
  "history": "static-4.47",
  "metrics-js": "static-1.9391",
  "PortalIdParser": "static-2.349",
  "portals-platform-lib": "static-1.537",
  "quartz-config": "static-1.511",
  "quartz-routing": "static-1.163",
  "quick-fetch": "static-1.3733",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "react-dom": "static-7.85",
  "react-rhumb": "static-1.16446",
  "react-router-dom": "static-5.26",
  "sanitize-text": "static-1.7938",
  "styled-components": "static-2.84",
  "tanstack-table": "static-1.50",
  "ui-addon-draggable": "static-3.4564",
  "ui-addon-react-router-dom": "static-1.9345",
  "usage-tracker": "static-1.7133",
  "usage-tracker-anonymous": "static-1.5550",
  "usage-tracker-core": "static-1.6983",
  "apollo-stack-hubspot": "static-3.79",
  "hs-promise-rejection-tracking": "static-1.5291",
  "raven": "static-3.5624",
  "raven-hubspot": "static-1.5931",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "react-redux": "static-7.66",
  "redux": "static-4.16",
  "bend-plugin-trellis-migration": "static-1.3225",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3010",
  "quartz-webpack": "static-1.2957",
  "fast-json-stable-stringify": "static-1.4",
  "graphql": "static-1.77",
  "customer-data-objects": "static-1.7447",
  "frontend-preferences-client": "static-1.7723",
  "laboratory-lib": "static-3.6959",
  "onboarding-scopes": "static-1.6261",
  "rpc-client-utils": "static-1.4432",
  "ui-addon-opt": "static-4.8183",
  "HeadJS": "static-2.709",
  "hs-test-utils-bend-plugin": "static-1.2915",
  "msw": "static-1.39",
  "testing-library": "static-1.147",
  "ts-schema": "static-1.3902",
  "webpack-env": "static-1.54",
  "content-assistance-lib": "static-1.7446",
  "cssUtils": "static-1.730",
  "customer-data-ui-utilities": "static-1.9622",
  "HubStyle": "static-2.11532",
  "knowledge-content-types": "static-1.8366",
  "PatternValidationJS": "static-1.437",
  "quartz-i18n": "static-1.408",
  "react-input-autosize": "static-2.17",
  "StyleGuideUI": "static-3.483",
  "ui-addon-emoji-picker": "static-1.9687",
  "ui-addon-i18n": "static-1.10937",
  "ui-business-units-lib": "static-1.8824",
  "ui-shepherd-react": "static-3.9944",
  "video-components-external": "static-1.10551",
  "i18n-data": "static-1.216",
  "moment-timezone": "static-5.78",
  "jasmine": "static-4.4125",
  "commerce-tours-lib": "static-1.5716",
  "customer-data-properties": "static-1.50789",
  "getting-started-shared-tasks": "static-1.17873",
  "growth-onboarding-reliability": "static-1.4884",
  "onboarding-tours": "static-1.16255",
  "reference-resolvers-lite": "static-1.7892",
  "sales-checkout-service-client": "static-1.3466",
  "ui-addon-iframeable": "static-1.8843",
  "user-context": "static-1.4897",
  "dispatcher": "static-1.132",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.793",
  "hubspotter-http": "static-1.4476",
  "icons": "static-2.622",
  "mobile-manifest-mixins": "static-1.482",
  "module-federation": "static-1.18",
  "quartz-auth": "static-1.408",
  "quartz-head": "static-1.398",
  "quartz-test": "static-1.408",
  "quartz-tracking": "static-1.112",
  "ui-fonts": "static-1.486",
  "usage-tracker-container": "static-1.7123",
  "csstype": "static-1.50",
  "hs-story-utils": "static-1.9226",
  "data-token-picker": "static-1.16038",
  "FileManagerLib": "static-1.38514",
  "property-translator": "static-1.5211",
  "atom": "static-1.4867",
  "merchandise-lib": "static-1.259",
  "purchase-motions-components": "static-1.5481",
  "salesImages": "static-1.520",
  "SharedI18nStrings": "static-1.180",
  "foundations-components-test-utils": "static-1.5003",
  "react-select-plus": "static-1.65",
  "react-virtualized": "static-2.94",
  "ui-images": "static-2.1090",
  "bend-plugin-foundations-components": "static-1.3789",
  "floating-ui": "static-1.51",
  "react-aria": "static-1.61",
  "trellis-assets": "static-1.1185",
  "bend-plugin-foundations-theming": "static-1.2691",
  "foundations-theming-base": "static-1.3193",
  "stylex": "static-1.27",
  "js-cookie": "static-1.18",
  "usage-tracker-multi": "static-1.5547",
  "autolinker": "static-3.11",
  "sanitize": "static-1.4272",
  "react-flip-move": "static-1.65",
  "bender-build-tools": "static-1.2937",
  "inbound-db-properties-service-client": "static-1.3673",
  "superstore": "static-1.4568",
  "feedback-loader": "static-1.28851",
  "ai-components-ui-library": "static-1.8339",
  "ui-addon-video-player": "static-1.8494",
  "ui-coaching-tips": "static-1.27934",
  "sassPrefix": "static-1.151",
  "react-dnd-compat": "static-1.4419",
  "react-immutable-proptypes": "static-2.8",
  "react-immutable-render-mixin": "static-1.9",
  "avatar-components": "static-1.2283",
  "redux-thunk": "static-2.43",
  "reference-resolvers": "static-1.7959",
  "reselect": "static-2.16",
  "apollo-link-hub-http": "static-2.4447",
  "content-media-composition-data-lib": "static-1.11443",
  "content-media-compositions": "static-2.15450",
  "idb-keyval": "static-1.39",
  "immer": "static-1.33",
  "immerable": "static-1.3952",
  "magpie-lib": "static-1.5392",
  "magpie-types": "static-1.4852",
  "media-bridge-lib": "static-1.18561",
  "video-data-lib": "static-1.34209",
  "commerce-products-lib": "static-1.8854",
  "crm-message-bus": "static-1.42353",
  "growth-data-modal": "static-1.5154",
  "hubspot-apollo-client": "static-1.4679",
  "onboarding-tours-client": "static-1.4469",
  "calling-global-api": "static-1.63655",
  "calling-internal-common": "static-1.31091",
  "calling-lifecycle-internal": "static-1.65037",
  "calling-lifecycle-messages": "static-1.57331",
  "conditional-properties-service-client": "static-1.3621",
  "crm-links": "static-1.6062",
  "customer-data-objects-ui-components": "static-1.12804",
  "customer-data-property-utils": "static-1.7875",
  "external-options-client-types": "static-1.3982",
  "file-manager-components": "static-1.22874",
  "framework-data-schema-resolvers": "static-1.6671",
  "google-libphonenumber": "static-1.33",
  "hs-entities": "static-1.476",
  "inbound-db-meta-service-client": "static-1.3415",
  "inbounddb-objects-service-types": "static-1.4047",
  "meetings-icalendar-utils-lib": "static-1.431",
  "multi-currency-client-types": "static-1.3515",
  "object-builder-ui-client": "static-1.47958",
  "pipeline-validation-client-types": "static-1.3784",
  "property-value-citations": "static-1.1403",
  "pulse": "static-1.309",
  "smart-property-lib": "static-1.5894",
  "tiered-pricing": "static-1.825",
  "ui-addon-form-validation": "static-1.10792",
  "growth-onboarding-confetti": "static-1.2869",
  "growth-onboarding-next-action-utils": "static-1.1297",
  "navigation-components": "static-1.17260",
  "onboarding-tours-utils": "static-1.321",
  "ui-shepherd-tracker": "static-1.7325",
  "ui-universal-auth": "static-1.8696",
  "batch-promise": "static-1.1348",
  "navigation-messaging": "static-1.6587",
  "getting-started-shared-tasks-store": "static-1.16991",
  "hubspotter-http-shared-msw-handlers": "static-1.9470",
  "audio-components": "static-1.5611",
  "FileManagerCore": "static-1.38373",
  "FileManagerImages": "static-1.36025",
  "video-components": "static-1.12554",
  "foundations-components-legacy": "static-1.545",
  "growth-monetization-service-types": "static-1.4312",
  "nav-client-types": "static-1.2155",
  "purchase-motions-api": "static-1.5484",
  "self-service-api": "static-1.10031",
  "signup-constants": "static-1.18389",
  "signup-ui-url-generator": "static-2.7858",
  "trials-service-types": "static-1.3713",
  "usage-tracker-public": "static-1.6944",
  "chatspot-core": "static-1.20295",
  "chirp-fetch": "static-1.1681",
  "ContentUtils": "static-1.67612",
  "copilot-toolkit": "static-1.10517",
  "growth-onboarding-feedback-components": "static-1.6382",
  "hls.js": "static-1.34",
  "reactive-lib": "static-1.523",
  "simple-logging-lib": "static-1.2848",
  "customer-data-tracking": "static-1.6679",
  "products-iframe-lib": "static-1.7305",
  "products-ui-components-shared-msw-handlers": "static-1.9854",
  "hubspot-apollo-cache": "static-1.138",
  "calling-error-reporting": "static-1.31097",
  "shared-worker-versioning": "static-1.10836",
  "calling-usage-tracker": "static-1.6338",
  "voice-sms-access-library": "static-1.236",
  "conversations-skeleton-state": "static-1.7046",
  "location-customization-utils-lib": "static-1.8548",
  "crm-pipelines-api-client-types": "static-1.3962",
  "framework-builder-read-service-client": "static-1.3831",
  "framework-data-schema-quick-fetch": "static-1.6576",
  "persist-promise": "static-1.3505",
  "directed-graph": "static-1.735",
  "event-emitter": "static-1.745",
  "breeze-intelligence-kit": "static-1.5319",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9555",
  "fsm": "static-1.3528",
  "policy-lib": "static-1.6583",
  "react-tinymce": "static-1.54607",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.9618",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.53733",
  "tinymce-plugins": "static-1.56847",
  "tinymce-themes": "static-1.55703",
  "unified-auth-core-lib": "static-1.491",
  "cropperjs": "static-1.10",
  "redux-toolkit": "static-1.7",
  "urlinator": "static-1.4330",
  "video-embed": "static-1.35043",
  "content-icons-ui": "static-1.2152",
  "social-insights-client-types": "static-1.21311",
  "eligibility-engine-service-types": "static-1.2994",
  "markdown-it": "static-1.6",
  "cms-field-types": "static-1.4605",
  "integrations-lib": "static-1.15401",
  "underscore": "static-1.8",
  "sales-views-client-types": "static-1.4085",
  "calling-orchestration-schema": "static-1.35013",
  "crm-record-cards-service-types": "static-1.3450",
  "highcharts": "static-8.99",
  "trellis-story-utils": "static-1.4320",
  "storybook-react": "static-1.28",
  "hub-http-contrib": "static-1.2842",
  "interframe": "static-3.4588",
  "tinymce-data": "static-1.39818",
  "ui-addon-sales-email": "static-1.5012",
  "codemirror": "static-5.90",
  "layout-dnd-components": "static-1.12030",
  "layout-dnd-utils": "static-1.11005",
  "react-codemirror": "static-1.10424",
  "ui-brand-identity-lib": "static-1.13864",
  "NamespacedHubStyle": "static-2.8894",
  "outpost": "static-1.4003",
  "flux-actions": "static-1.309",
  "integrations-error-boundary-lib": "static-1.12816",
  "integrations-tracking-lib": "static-1.5386",
  "native-integrations-shared-strings": "static-1.7586",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10170",
  "rxjs": "static-5.10",
  "diff-match-patch": "static-1.7",
  "ContentData": "static-1.67687",
  "layout-data-lib": "static-1.9330",
  "browser-eslint": "static-2.57",
  "universal-page-editor-lib": "static-1.2797",
  "advanced-menus-core": "static-1.14812",
  "advanced-menus-lib": "static-1.11786",
  "ExportDialog": "static-6.10185",
  "ui-memberships-settings-lib": "static-1.33418",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.14811",
  "simple-menus-lib": "static-1.16328"
},
  depPathPrefixes: {
  "customer-portal-app": "/customer-portal-app/static-1.1660",
  "apollo-dlb": "/apollo-dlb/static-3.80",
  "client-types": "/client-types/static-1.445",
  "data-fetching-client": "/data-fetching-client/static-1.9477",
  "emoji-mart": "/emoji-mart/static-3.4",
  "enviro": "/enviro/static-4.387",
  "growth-payments-core": "/growth-payments-core/static-1.24718",
  "head-dlb": "/head-dlb/static-1.4754",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.5391",
  "hs-test-utils": "/hs-test-utils/static-1.7804",
  "hub-http": "/hub-http/static-1.5966",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9472",
  "hubspot-dlb": "/hubspot-dlb/static-2.1796",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.17595",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.3917",
  "HubStyleTokens": "/HubStyleTokens/static-2.11224",
  "I18n": "/I18n/static-7.1568",
  "immutable": "/immutable/static-2.19",
  "jasmine-runner": "/jasmine-runner/static-1.6271",
  "payment-link-components": "/payment-link-components/static-1.22932",
  "prosemirror": "/prosemirror/static-1.13",
  "quartz": "/quartz/static-1.6733",
  "quartz-core": "/quartz-core/static-1.5952",
  "react": "/react/static-7.177",
  "react-colorpicker": "/react-colorpicker/static-2.10008",
  "react-dlb": "/react-dlb/static-1.71",
  "react-utils": "/react-utils/static-2.5171",
  "rich-text-lib": "/rich-text-lib/static-1.19466",
  "transmute": "/transmute/static-2.85",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17650",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.5362",
  "UIComponents": "/UIComponents/static-3.8171",
  "foundations-assets": "/foundations-assets/static-1.4635",
  "foundations-components": "/foundations-components/static-1.7520",
  "foundations-theming": "/foundations-theming/static-1.4208",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1924",
  "framer-motion": "/framer-motion/static-1.67",
  "history": "/history/static-4.47",
  "metrics-js": "/metrics-js/static-1.9391",
  "PortalIdParser": "/PortalIdParser/static-2.349",
  "portals-platform-lib": "/portals-platform-lib/static-1.537",
  "quartz-config": "/quartz-config/static-1.511",
  "quartz-routing": "/quartz-routing/static-1.163",
  "quick-fetch": "/quick-fetch/static-1.3733",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "react-dom": "/react-dom/static-7.85",
  "react-rhumb": "/react-rhumb/static-1.16446",
  "react-router-dom": "/react-router-dom/static-5.26",
  "sanitize-text": "/sanitize-text/static-1.7938",
  "styled-components": "/styled-components/static-2.84",
  "tanstack-table": "/tanstack-table/static-1.50",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4564",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9345",
  "usage-tracker": "/usage-tracker/static-1.7133",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5550",
  "usage-tracker-core": "/usage-tracker-core/static-1.6983",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.79",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5291",
  "raven": "/raven/static-3.5624",
  "raven-hubspot": "/raven-hubspot/static-1.5931",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "react-redux": "/react-redux/static-7.66",
  "redux": "/redux/static-4.16",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3225",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3010",
  "quartz-webpack": "/quartz-webpack/static-1.2957",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "graphql": "/graphql/static-1.77",
  "customer-data-objects": "/customer-data-objects/static-1.7447",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7723",
  "laboratory-lib": "/laboratory-lib/static-3.6959",
  "onboarding-scopes": "/onboarding-scopes/static-1.6261",
  "rpc-client-utils": "/rpc-client-utils/static-1.4432",
  "ui-addon-opt": "/ui-addon-opt/static-4.8183",
  "HeadJS": "/HeadJS/static-2.709",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2915",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.147",
  "ts-schema": "/ts-schema/static-1.3902",
  "webpack-env": "/webpack-env/static-1.54",
  "content-assistance-lib": "/content-assistance-lib/static-1.7446",
  "cssUtils": "/cssUtils/static-1.730",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9622",
  "HubStyle": "/HubStyle/static-2.11532",
  "knowledge-content-types": "/knowledge-content-types/static-1.8366",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "quartz-i18n": "/quartz-i18n/static-1.408",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "StyleGuideUI": "/StyleGuideUI/static-3.483",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9687",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.10937",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.8824",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.9944",
  "video-components-external": "/video-components-external/static-1.10551",
  "i18n-data": "/i18n-data/static-1.216",
  "moment-timezone": "/moment-timezone/static-5.78",
  "jasmine": "/jasmine/static-4.4125",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.5716",
  "customer-data-properties": "/customer-data-properties/static-1.50789",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.17873",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4884",
  "onboarding-tours": "/onboarding-tours/static-1.16255",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7892",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3466",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8843",
  "user-context": "/user-context/static-1.4897",
  "dispatcher": "/dispatcher/static-1.132",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.793",
  "hubspotter-http": "/hubspotter-http/static-1.4476",
  "icons": "/icons/static-2.622",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.482",
  "module-federation": "/module-federation/static-1.18",
  "quartz-auth": "/quartz-auth/static-1.408",
  "quartz-head": "/quartz-head/static-1.398",
  "quartz-test": "/quartz-test/static-1.408",
  "quartz-tracking": "/quartz-tracking/static-1.112",
  "ui-fonts": "/ui-fonts/static-1.486",
  "usage-tracker-container": "/usage-tracker-container/static-1.7123",
  "csstype": "/csstype/static-1.50",
  "hs-story-utils": "/hs-story-utils/static-1.9226",
  "data-token-picker": "/data-token-picker/static-1.16038",
  "FileManagerLib": "/FileManagerLib/static-1.38514",
  "property-translator": "/property-translator/static-1.5211",
  "atom": "/atom/static-1.4867",
  "merchandise-lib": "/merchandise-lib/static-1.259",
  "purchase-motions-components": "/purchase-motions-components/static-1.5481",
  "salesImages": "/salesImages/static-1.520",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.180",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5003",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-virtualized": "/react-virtualized/static-2.94",
  "ui-images": "/ui-images/static-2.1090",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3789",
  "floating-ui": "/floating-ui/static-1.51",
  "react-aria": "/react-aria/static-1.61",
  "trellis-assets": "/trellis-assets/static-1.1185",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2691",
  "foundations-theming-base": "/foundations-theming-base/static-1.3193",
  "stylex": "/stylex/static-1.27",
  "js-cookie": "/js-cookie/static-1.18",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.5547",
  "autolinker": "/autolinker/static-3.11",
  "sanitize": "/sanitize/static-1.4272",
  "react-flip-move": "/react-flip-move/static-1.65",
  "bender-build-tools": "/bender-build-tools/static-1.2937",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3673",
  "superstore": "/superstore/static-1.4568",
  "feedback-loader": "/feedback-loader/static-1.28851",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8339",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8494",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.27934",
  "sassPrefix": "/sassPrefix/static-1.151",
  "react-dnd-compat": "/react-dnd-compat/static-1.4419",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "avatar-components": "/avatar-components/static-1.2283",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reference-resolvers": "/reference-resolvers/static-1.7959",
  "reselect": "/reselect/static-2.16",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4447",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.11443",
  "content-media-compositions": "/content-media-compositions/static-2.15450",
  "idb-keyval": "/idb-keyval/static-1.39",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.3952",
  "magpie-lib": "/magpie-lib/static-1.5392",
  "magpie-types": "/magpie-types/static-1.4852",
  "media-bridge-lib": "/media-bridge-lib/static-1.18561",
  "video-data-lib": "/video-data-lib/static-1.34209",
  "commerce-products-lib": "/commerce-products-lib/static-1.8854",
  "crm-message-bus": "/crm-message-bus/static-1.42353",
  "growth-data-modal": "/growth-data-modal/static-1.5154",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4679",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4469",
  "calling-global-api": "/calling-global-api/static-1.63655",
  "calling-internal-common": "/calling-internal-common/static-1.31091",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.65037",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.57331",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3621",
  "crm-links": "/crm-links/static-1.6062",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12804",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.7875",
  "external-options-client-types": "/external-options-client-types/static-1.3982",
  "file-manager-components": "/file-manager-components/static-1.22874",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6671",
  "google-libphonenumber": "/google-libphonenumber/static-1.33",
  "hs-entities": "/hs-entities/static-1.476",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3415",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4047",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.431",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3515",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.47958",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3784",
  "property-value-citations": "/property-value-citations/static-1.1403",
  "pulse": "/pulse/static-1.309",
  "smart-property-lib": "/smart-property-lib/static-1.5894",
  "tiered-pricing": "/tiered-pricing/static-1.825",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10792",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2869",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1297",
  "navigation-components": "/navigation-components/static-1.17260",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.321",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7325",
  "ui-universal-auth": "/ui-universal-auth/static-1.8696",
  "batch-promise": "/batch-promise/static-1.1348",
  "navigation-messaging": "/navigation-messaging/static-1.6587",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.16991",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9470",
  "audio-components": "/audio-components/static-1.5611",
  "FileManagerCore": "/FileManagerCore/static-1.38373",
  "FileManagerImages": "/FileManagerImages/static-1.36025",
  "video-components": "/video-components/static-1.12554",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.545",
  "growth-monetization-service-types": "/growth-monetization-service-types/static-1.4312",
  "nav-client-types": "/nav-client-types/static-1.2155",
  "purchase-motions-api": "/purchase-motions-api/static-1.5484",
  "self-service-api": "/self-service-api/static-1.10031",
  "signup-constants": "/signup-constants/static-1.18389",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7858",
  "trials-service-types": "/trials-service-types/static-1.3713",
  "usage-tracker-public": "/usage-tracker-public/static-1.6944",
  "chatspot-core": "/chatspot-core/static-1.20295",
  "chirp-fetch": "/chirp-fetch/static-1.1681",
  "ContentUtils": "/ContentUtils/static-1.67612",
  "copilot-toolkit": "/copilot-toolkit/static-1.10517",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6382",
  "hls.js": "/hls.js/static-1.34",
  "reactive-lib": "/reactive-lib/static-1.523",
  "simple-logging-lib": "/simple-logging-lib/static-1.2848",
  "customer-data-tracking": "/customer-data-tracking/static-1.6679",
  "products-iframe-lib": "/products-iframe-lib/static-1.7305",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.9854",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.138",
  "calling-error-reporting": "/calling-error-reporting/static-1.31097",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.10836",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6338",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.236",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7046",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8548",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.3962",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3831",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6576",
  "persist-promise": "/persist-promise/static-1.3505",
  "directed-graph": "/directed-graph/static-1.735",
  "event-emitter": "/event-emitter/static-1.745",
  "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.5319",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9555",
  "fsm": "/fsm/static-1.3528",
  "policy-lib": "/policy-lib/static-1.6583",
  "react-tinymce": "/react-tinymce/static-1.54607",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9618",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.53733",
  "tinymce-plugins": "/tinymce-plugins/static-1.56847",
  "tinymce-themes": "/tinymce-themes/static-1.55703",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.491",
  "cropperjs": "/cropperjs/static-1.10",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "urlinator": "/urlinator/static-1.4330",
  "video-embed": "/video-embed/static-1.35043",
  "content-icons-ui": "/content-icons-ui/static-1.2152",
  "social-insights-client-types": "/social-insights-client-types/static-1.21311",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.2994",
  "markdown-it": "/markdown-it/static-1.6",
  "cms-field-types": "/cms-field-types/static-1.4605",
  "integrations-lib": "/integrations-lib/static-1.15401",
  "underscore": "/underscore/static-1.8",
  "sales-views-client-types": "/sales-views-client-types/static-1.4085",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35013",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3450",
  "highcharts": "/highcharts/static-8.99",
  "trellis-story-utils": "/trellis-story-utils/static-1.4320",
  "storybook-react": "/storybook-react/static-1.28",
  "hub-http-contrib": "/hub-http-contrib/static-1.2842",
  "interframe": "/interframe/static-3.4588",
  "tinymce-data": "/tinymce-data/static-1.39818",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5012",
  "codemirror": "/codemirror/static-5.90",
  "layout-dnd-components": "/layout-dnd-components/static-1.12030",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11005",
  "react-codemirror": "/react-codemirror/static-1.10424",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.13864",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8894",
  "outpost": "/outpost/static-1.4003",
  "flux-actions": "/flux-actions/static-1.309",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.12816",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5386",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7586",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10170",
  "rxjs": "/rxjs/static-5.10",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ContentData": "/ContentData/static-1.67687",
  "layout-data-lib": "/layout-data-lib/static-1.9330",
  "browser-eslint": "/browser-eslint/static-2.57",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2797",
  "advanced-menus-core": "/advanced-menus-core/static-1.14812",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.11786",
  "ExportDialog": "/ExportDialog/static-6.10185",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33418",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.14811",
  "simple-menus-lib": "/simple-menus-lib/static-1.16328"
}
};
